import { AreaBookingAPI } from "../api"
import { Area } from "./Area.class";
import moment from 'moment'
import i18n from '@/plugins/vue-i18n';

export class AreaBooking {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    if (this.area) {
      this.area = new Area(this.area)
    }
  }
  static async createAreaBooking(formData) {
    const { data } = await AreaBookingAPI.createAreaBooking(formData)
    return new AreaBooking(data.result)
  }
  static async editAreaBooking(formData) {
    const { data } = await AreaBookingAPI.editAreaBooking(formData)
    return new AreaBooking(data.result)
  }
  static async checkInAreaBooking(formData) {
    const { data } = await AreaBookingAPI.checkInAreaBooking(formData)
    return new AreaBooking(data.result)
  }
  static async checkOutAreaBooking(formData) {
    const { data } = await AreaBookingAPI.checkOutAreaBooking(formData)
    return new AreaBooking(data.result)
  }
  static async cancelAreaBooking(areaBookingId) {
    const { data } = await AreaBookingAPI.cancelAreaBooking(areaBookingId)
    return new AreaBooking(data.result)
  }
  static async getAreaBookingByBooking(bookingId) {
    const { data } = await AreaBookingAPI.getAreaBookingByBooking(bookingId)
    return data.result.map(item => new AreaBooking(item));
  }
  static async getAreaBookingBetweenDate(formData) {
    const { data } = await AreaBookingAPI.getAreaBookingBetweenDate(formData);
    return data.result.map(item => new AreaBooking(item));
  }
  static async getAreaBookingByArea(areaId) {
    const { data } = await AreaBookingAPI.getAreaBookingByArea(areaId)
    return new AreaBooking(data.result)
  }
  static async getAreaBookingCheckedInDateBetweenDate(formData) {
    const { data } = await AreaBookingAPI.getAreaBookingCheckedInDateBetweenDate(formData);
    return data.result.map(item => new AreaBooking(item));
  }
  static async getCheckinAreaBookingByAreas(formData) {
    const { data } = await AreaBookingAPI.getCheckinAreaBookingByAreas(formData)
    return data.result.map(item => new AreaBooking(item));
  }
  get bookingDate() {
    const dailyFormat = 'DD MMM YYYY HH:mm'
    const monthlyFormat = 'DD MMM YYYY'
    let date = ''
    if (this.startDate && this.endDate) {
      date = `${moment(this.startDate.iso).format(this.type == 'daily' ? dailyFormat : monthlyFormat)} - ${moment(this.endDate.iso).format(this.type == 'daily' ? dailyFormat : monthlyFormat)}`
    }
    return date
  }
  get checkedInDateFormat() {
    const dailyFormat = 'DD MMM YYYY HH:mm'
    const monthlyFormat = 'DD MMM YYYY'
    let date = ''
    if (this.checkedInDate)
      date = `${moment(this.checkedInDate.iso).format(this.type == 'daily' ? dailyFormat : monthlyFormat)}`
    else date = '-'
    return date
  }
  get checkedOutDateFormat() {
    const dailyFormat = 'DD MMM YYYY HH:mm'
    const monthlyFormat = 'DD MMM YYYY'
    let date = ''
    if (this.checkedOutDate)
      date = `${moment(this.checkedOutDate.iso).format(this.type == 'daily' ? dailyFormat : monthlyFormat)}`
    else date = '-'
    return date
  }
  get diffDays() {
    let days = 0;
    let minutes = 0;
    if (this.startDate.iso && this.endDate.iso) {
      minutes =
        moment(this.endDate.iso).diff(
          moment(this.startDate.iso),
          "minutes"
        ) || 0;
      days = Math.ceil(minutes / (24 * 60));
    }
    return days;
  }
  get statusChips() {
    let status = []
    if (this.area) {
      //this.area.contract
      if (this.area.areaBooking && this.area.areaBooking.objectId) {
        status.push({
          text: i18n.t('area.enter_stall'),
          color: 'info'
        })
      } else {
        status.push({
          text: i18n.t('area.empty_stall'),
          color: ''
        })
      }
      if (this.area.numOfAreaBooking > 0) {
        status.push({
          text: i18n.t('booked'),
          color: 'warning'
        })
      }
    }

    return status
  }
}